let fetchPromise: Promise<void>;

let getScript = () => {
  return new Promise<void>((resolve, reject) => {
    let script = document.createElement('script');
    script.src = 'https://use.feedback.onhighloop.com/core/index.umd.js';
    script.onload = () => {
      resolve();
    };
    script.onerror = err => {
      console.warn('[highloop-feedback]: could not fetch script');
      reject(err);
    };

    document.body.appendChild(script);
  });
};

export let scriptManager = () => {
  if (!fetchPromise) fetchPromise = getScript();
  return fetchPromise;
};
